import React, { useState,useEffect } from 'react';
import { BlockStack, Card, Layout, Page, SkeletonBodyText, SkeletonPage } from "@shopify/polaris";
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import utils from '../../../../utils/utils'
import AppBridge from '../../../../utils/appBridge';
import intl from '../../../../i18n/intl';
import { Carousel } from 'react-responsive-carousel';

let icon1 = <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.92248 0.169138C8.84245 0.00697546 8.61121 0.00697558 8.53118 0.169138L6.21271 4.86686C6.18093 4.93126 6.1195 4.97589 6.04843 4.98622L0.864189 5.73953C0.685232 5.76554 0.613775 5.98546 0.743269 6.11168L4.49462 9.76835C4.54605 9.81847 4.56951 9.89069 4.55737 9.96147L3.6718 15.1248C3.64123 15.303 3.82831 15.4389 3.98837 15.3548L8.6253 12.917C8.68886 12.8836 8.7648 12.8836 8.82836 12.917L13.4653 15.3548C13.6254 15.4389 13.8124 15.303 13.7819 15.1248L12.8963 9.96147C12.8841 9.89069 12.9076 9.81847 12.959 9.76835L16.7104 6.11168C16.8399 5.98546 16.7684 5.76554 16.5895 5.73953L11.4052 4.98622C11.3342 4.97589 11.2727 4.93126 11.2409 4.86686L8.92248 0.169138Z" fill="#FFBB1C"/>
</svg>
const LandingPageClass = () => {

  /**
   * 跳转 POD安装页面
   */
  const handleLink = () => {
    let podAppInstall = 'https://gempages.net/?ref=43vf4Etf';

    try {
      const w = window.open('about:blank');
      w.location.href = podAppInstall;

    } catch (error) {
      window.open(podAppInstall, '_blank')
    }
  }
const router = useHistory();
const [loading,setLoading] = useState(false);
const [data,setData] = useState({
  toggleData:[
    {
      title:'Drag-and-drop Visual Editor',
      desc1:'Whether it’s a landing page, product page, or homepage, effortlessly design any page type with a user-friendly interface,',
      desc2:'',
      strong:'featuring 100+ conversion-driven elements.',
      select:1,
      image:'/gempage/toggle_img1.png'
    },
    {
      title:'AI-Powered Image-to-Layout',
      desc1:'Our AI feature, powered by GemAI, helps you instantly streamlining your page building.',
      desc2:'streamlining your page building.',
      strong:'generate editable layouts from reference images and URLs,',
      select:0,
      image:'/gempage/toggle_img2.png'
    },
    {
      title:'CRO Template Library',
      desc1:'to create professional pages without starting from scratch.',
      desc2:'',
      strong:'Access 80+ CRO-driven templates',
      select:0,
      image:'/gempage/toggle_img3.png'
    },
  ]
})
const [currentIndex,setCurrentIndex] = useState(0)
const handleToggleImage = (key)=>{
      let list = data.toggleData.map((item,ind)=>{
        if(ind === key) {
          item.select = 1
        } else {
          item.select = 0
        }
        return item
      })
      setCurrentIndex(key)
      setData((prevValue)=>({
        ...prevValue,
        toggleData:list
      }))
}
useEffect(() => {
  let isMount = false;
  if (!isMount) {
    setLoading(true)
    // if(AppBridge && AppBridge.exist()) {
    //   AppBridge.setTitleBar('Landing Page Builder','/admin/customService')
    // }
    setTimeout(() => {
      setLoading(false)
    }, 1000);
  }
  return () => {
    isMount = true
  };
}, []);

const initSkeletonPage = (
  <div>
    <SkeletonPage fullWidth={false}>
    <Layout>
          <Layout.Section>
          <Card>
          <BlockStack gap={400}>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          </BlockStack>
          </Card>
        </Layout.Section>
          </Layout>
    </SkeletonPage>
  </div>
);
const globalConfig2 = {
  showArrows: false,
  autoPlay: true,
  interval: 5000,
  showIndicators:false,
  showStatus: false,
  infiniteLoop: true,
  showThumbs: false,
};
  return loading ? initSkeletonPage :  (
    <Page
      title={AppBridge.exist() ? "" : <div style={{fontSize:'20px'}} >{intl.get("Gempages Landing Page Builder")}</div>}
      backAction={AppBridge.exist() ? undefined : {content: 'Gempages Landing Page Builder', onAction: () =>{utils.routeListen('/admin/customService')
      utils.routeJump1(router,'/admin/customService')}}}
      fullWidth={false}
    >
       <div className='land_content'>
        <div className='land_top'> 
          <div className='land_top_t'>
          <div className='land_top_t_l'> <img src={'/gempage/gem_logo.png'} alt="Dropshipman" /></div>
          <div className='land_top_t_r' onClick={()=>handleLink()}>Start for Free</div>
          </div>
          <div className='land_top_m'>
          <div className='land_top_m_l'>
          <div className='land_top_m_l_star'>
            <span>{icon1}</span>
            <span className='white'>4000+ </span>
            5-Star Reviews
          </div>
          <div className='land_top_m_l_yellow'>
            <p>Top-Ranked shopify Page Builer</p>
          </div>
          <div className='land_top_m_l_title'>
            <h1>Effortlessly design professional, conversion-focused 
           <br /> Shopify pages
            </h1>
          </div>
          <div className='land_top_m_l_p'>
            <p>GemPages helps you create, customize, and optimize Shopify pages that look good and sell fast. No coding.
            </p>
          </div>
          <div className='land_top_m_l_button' onClick={()=>handleLink()}>
          Start for Free
          </div>
          </div>
          <div className='land_top_m_r'><img src={'/gempage/top_banner.png'} alt="Dropshipman" /></div>
          </div>
          <div className='land_top_b'>
            <div className='land_top_b_title'>
              <p>GemPages empowers <strong>165,000+</strong> Shopify merchants and brands across <strong>130+</strong> countries to create over <strong>1,800,000</strong> pages.</p>
            </div>
            <div className='land_top_b_partner'>
              <div>
                <img src={'/gempage/partner_1.png'} alt="Dropshipman" />
                <img src={'/gempage/partner_2.png'} alt="Dropshipman" />
                <img src={'/gempage/partner_3.png'} alt="Dropshipman" />
                <img src={'/gempage/partner_4.png'} alt="Dropshipman" />
                <img src={'/gempage/partner_5.png'} alt="Dropshipman" />
                <img src={'/gempage/partner_6.png'} alt="Dropshipman" />
              </div>
            </div>
          </div>
        </div>
        <div className='land_mid1'>
          <div className='land_mid1_t'>
            <h2>Create high-converting pages with GemPages smart features</h2>
          </div>
          <div className='land_mid1_b'>
            <div className='land_mid1_b_l'>
            <img src={data.toggleData[currentIndex].image} alt="Dropshipman" />
            </div>
            <div className='land_mid1_b_r'>
              
              <div className='land_mid1_b_list'>
              {data.toggleData.map((item,ind)=><div className='land_mid1_b_list_item' key={ind}>
                {item.select === 1 ? <div className='land_mid1_b_list_item_li land_mid1_b_list_item_lis'>
                <div className='land_mid1_b_list_item_title'>
                  {item.title}
                </div>
                {ind === 0 &&<p>{item.desc1} <strong>{item.strong}</strong></p>}
                {ind === 1 &&<p>{item.desc1} <strong>{item.strong}</strong> {item.desc2}</p>}
                {ind === 2 &&<p><strong>{item.strong}</strong> {item.desc1} </p>}
                </div>:<div className='land_mid1_b_list_item_li' onClick={()=>{handleToggleImage(ind)}}>
                <div className='land_mid1_b_list_item_title'>
                  {item.title}
                </div></div>}
              </div>)}
              </div>
              
            </div>
          </div>
          <Carousel {...globalConfig2}>
          {data.toggleData.map((item,ind)=><div key={ind} className='land_mid1_b land_mid1_b_c'>
            <div className='land_mid1_b_l'>
            <img src={data.toggleData[ind].image} alt="Dropshipman" />
            </div>
            <div className='land_mid1_b_r'>
              <div className='land_mid1_b_list'>
              <div className='land_mid1_b_list_item' >
                <div className='land_mid1_b_list_item_li land_mid1_b_list_item_lis'>
                <div className='land_mid1_b_list_item_title'>
                  {item.title}
                </div>
                {ind === 0 &&<p>{item.desc1} <strong>{item.strong}</strong></p>}
                {ind === 1 &&<p>{item.desc1} <strong>{item.strong}</strong> {item.desc2}</p>}
                {ind === 2 &&<p><strong>{item.strong}</strong> {item.desc1} </p>}
                </div>
              </div>
              </div>
            </div>
          </div>)}
          </Carousel>
        </div>
        <div className='land_mid2'>
        <div className='land_mid2_t'>
          <h2>Enjoy extensive resources to build pages that sell</h2>
          </div>
          <div className='land_mid2_b'>
            <div className='land_mid2_b_item'>
              <div className='land_mid2_b_item_icon'><img src={'/gempage/mid1_img1.png'} alt="Dropshipman" /></div>
              <div className='land_mid2_b_item_title'>GemPages YouTube</div>
              <div className='land_mid2_b_item_p'>Find all the introductions to elements and features, comprehensive tutorials, and expert building tips visually on our YouTube channel.</div>
            </div>
            <div className='land_mid2_b_item'>
              <div className='land_mid2_b_item_icon'><img src={'/gempage/mid1_img2.png'} alt="Dropshipman" /></div>
              <div className='land_mid2_b_item_title'>GemPages Academy</div>
              <div className='land_mid2_b_item_p'>Discover a wealth of resources at GemAcademy, offering both fundamental & advanced materials, courses, exclusive discount designed specifically for GemPages users.</div>
            </div>
            <div className='land_mid2_b_item'>
              <div className='land_mid2_b_item_icon'><img src={'/gempage/mid1_img3.png'} alt="Dropshipman" /></div>
              <div className='land_mid2_b_item_title'>GemPages Community</div>
              <div className='land_mid2_b_item_p'>Become a part of the GemPages community; tap into a network of experts and like-minded individuals for valuable insights, support, and chances to collaborate.</div>
            </div>
          </div>
        </div>
        
        <div className='land_bottom'>
          <div className='land_bottom_h2'>
          <h2>Turn clicks into sales. Build with GemPages today</h2>
          </div>
          <div className='land_bottom_p'>
          Unlock GemPages' potential to create professional pages that convert now
          </div>
          <div className='land_bottom_botton' onClick={()=>handleLink()}>
          Start for Free
          </div>
        </div>
       </div>
    </Page>
  );
}

export default LandingPageClass;